module.exports = __webpack_public_path__ + "img/Skirt-Front-B3-Da-Gd-Ha-Ia.e3aab21b.png";